import xor from 'lodash/xor'

import UserSelector from 'modules/core/components/UserSelector'
import users from 'modules/core/store/collections/users'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'

interface Props {
  resourceIds: number[]
  setResourceIds: (ids: number[]) => void
  contractVersions: ContractVersions
}

const ResourceTypes = ({ resourceIds, setResourceIds, contractVersions }: Props) => {
  const onSelect = (accessId: number | null | undefined) => {
    if (!accessId) return setResourceIds([])
    setResourceIds(xor(resourceIds, [accessId]))
  }
  const setAssignees = (ids: number[]) => {
    setResourceIds(ids)
  }
  const invitedEmployees = users.notTerminatedExcludingExternals.filter((user) => user.invited)
  return (
    <UserSelector
      onSelect={onSelect}
      selectedIds={resourceIds}
      onSelectMultiple={setAssignees}
      users={invitedEmployees}
      contractVersions={contractVersions}
    />
  )
}
export default ResourceTypes
